import React, { Component, Fragment } from 'react';
import map from 'lodash.map';
import orderBy from 'lodash.orderby';

export class ActElementPodpis extends Component {
	render() {
		const { childrens, attributes } = this.props;
		return (
			<div>
				{map(orderBy(childrens, (c) => c.order), (child) => (
					<Fragment>
						{child.name === 'funkcja' && (
							<div>
								<i className="text">{child.text}</i>
							</div>
						)}
					</Fragment>
				))}
                {attributes.name && attributes.surname && <div><i className="text">{attributes.name} {attributes.surname}</i></div>}
			</div>
		);
	}
}
